import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCap, Clock, DollarSign, MessageCircle, User, Heart } from 'lucide-react';
import { useSiteContent } from '../../context/SiteContentContext';

const iconMap = {
  GraduationCap,
  Clock,
  DollarSign,
  MessageCircle,
  User,
  Heart
};

const colorMap = [
  'bg-blue-50 text-blue-600',
  'bg-amber-50 text-amber-600',
  'bg-green-50 text-green-600',
  'bg-purple-50 text-purple-600',
  'bg-rose-50 text-rose-600',
  'bg-cyan-50 text-cyan-600'
];

const WhyChooseUs = () => {
  const { siteContent } = useSiteContent();
  const section = siteContent?.whyChooseUs || {};
  
  if (section.visible === false) return null;

  const title = section.title || 'Why Choose English Passion';
  const subtitle = section.subtitle || 'Discover what makes us different';
  const items = section.items || [];

  return (
    <section className="py-16 sm:py-20 md:py-24 bg-slate-50" data-testid="why-choose-us-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 md:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold text-slate-900 mb-4">
            {title}
          </h2>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto">
            {subtitle}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {items.map((item, index) => {
            const IconComponent = iconMap[item.icon] || GraduationCap;
            const colorClass = colorMap[index % colorMap.length];
            const itemTitle = item.title || '';
            const itemDescription = item.description || '';
            
            return (
              <motion.div
                key={`why-choose-${index}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white rounded-2xl p-6 md:p-8 border border-slate-100 shadow-sm hover:shadow-md transition-shadow"
              >
                <div className={`w-12 h-12 rounded-xl ${colorClass} flex items-center justify-center mb-4`}>
                  <IconComponent className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-semibold text-slate-900 mb-2">
                  {itemTitle}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {itemDescription}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
